import "./Icon_module.css";
const Icon_module_rslib_entry_ = {
    size50: "size50-LU0ErZ",
    size75: "size75-rCt7v9",
    size100: "size100-iXFRZP",
    size150: "size150-RtBfnD",
    size200: "size200-knkahW",
    size300: "size300-TRBo_Q",
    size400: "size400-bmu87M",
    size500: "size500-TTCU2U",
    size625: "size625-RD24KV",
    size750: "size750-etkn8t"
};
export { Icon_module_rslib_entry_ as default };

//# sourceMappingURL=Icon.module.js.map